<template>
  <div
    class="inputDiv"
    :class="error ? '-error': ''"
    @click="handleClick()"
  >
    <span class="inputLabel">{{ label }}</span>
    <input
      :placeholder="setPlaceholder"
      class="inputText"
      :type="setType"
      v-model="internalValue"
      ref="input"
      v-mask="mask"
      @blur="validateInput()"
      @focus="error = false"
      :autocomplete="setTypeAutocomplete"
      name="styled-input"
    />
    <c-icon
      v-if="type === 'password'"
      icon="eye"
      size="15px"
      @click.native="showPassword = !showPassword"
    />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  directives: {
    mask (el, binding) {
      if (!binding.value || !binding.value.length) { return }

      return mask(el, binding)
    }
  },
  props: {
    value: {
      type: String,
      default: function () {
        return ''
      }
    },
    label: {
      type: String,
      default: function () {
        return ''
      }
    },
    type: {
      type: String,
      default: function () {
        return 'text'
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return ''
      }
    },
    email: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    errorMessage: {
      type: String,
      default: function () {
        return 'O campo não pode estar vazio'
      }
    },
    mask: {
      type: undefined
    }
  },
  data () {
    return {
      internalValue: '',
      error: false,
      showPassword: false
    }
  },
  computed: {
    setPlaceholder () {
      if (this.error) return this.errorMessage
      return this.placeholder
    },
    setType () {
      if (this.type === 'password') {
        if (this.showPassword) return 'text'
        return 'password'
      }
      return 'text'
    },
    setTypeAutocomplete () {
      if (this.type === 'password') return 'new-password'
      return 'off'
    }
  },
  watch: {
    internalValue: {
      handler: function () {
        if (!this.error) this.$emit('input', this.internalValue)
      },
      deep: true
    }
  },
  created () {
    this.internalValue = JSON.parse(JSON.stringify(this.value))
  },
  methods: {

    validateInput () {
      if (this.internalValue === '') this.error = true
      else this.error = false
      this.verifyEmail()
    },

    handleClick () {
      this.error = false
      this.$refs.input.focus()
    },

    verifyEmail () {
      if (this.email) {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.internalValue)) this.error = false
        else this.error = true
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.inputDiv{
  background-color: #FFFFFF;
  border-radius: 5px;
  box-shadow: lightgrey 0px 1px 3px 0px;
  margin: 5px;
  width: 458px;
  height: 60px;
 padding: 8px 0px;
 @media screen and (max-width: 850px)  {
    width: unset;
  }
  & > .inputLabel{
  padding: 20px;
  color: #121E48;
  font-size: 11px;
}
}

.inputText {
  background: #fff;
  padding: 0px 20px;
  text-align: left;
  width: 93%;
  border: none !important;
  -webkit-appearance: none !important;
}

.inputText:focus {
  outline: none !important;
}

.-error{
  box-shadow: red 0px 0px 5px 0px;
  & ::placeholder{
      color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CInputStyled.vue